import { AnnotationsLayer } from '@/shared/api/protocol-ts/model/dto_common_image_annotations_pb';
import { Annotation } from '@/shared/graphics/RenderComponents/AnnotationsLayer/Annotation';

// TODO [4|h]: need to refactor this function to aviod reduce inside reduce inside reduce
export const makeAnnotations = (
  annotations: AnnotationsLayer[] = [],
): Annotation[] =>
  annotations.reduce((annotationsAcc, item) => {
    const polyLines = item.Annotations.reduce((polyLinesAcc, annotation) => {
      if (annotation.Type.case === 'PolyLine') {
        const points = annotation.Type.value.Points;

        const lines = points?.reduce((linesAcc, line, lineIndex) => {
          if (lineIndex > 0) {
            const currentLine = {
              kind: 'line',
              x1: line.X,
              x2: points[lineIndex - 1].X,
              y1: line.Y,
              y2: points[lineIndex - 1].Y,
            } as Annotation;
            linesAcc.push(currentLine);
          }

          return linesAcc;
        }, [] as Annotation[]);
        polyLinesAcc.push(...lines);
      }
      if (annotation.Type.case === 'Angle') {
        const angle = {
          kind: 'angle',
          x1: annotation.Type.value.Start?.X,
          y1: annotation.Type.value.Start?.Y,
          x2: annotation.Type.value.End?.X,
          y2: annotation.Type.value.End?.Y,
          x3: annotation.Type.value.Corner?.X,
          y3: annotation.Type.value.Corner?.Y,
        } as Annotation;
        polyLinesAcc.push(angle);
      }
      if (annotation.Type.case === 'Arrow') {
        const arrow = {
          kind: 'arrow',
          x1: annotation.Type.value.Start?.X,
          x2: annotation.Type.value.End?.X,
          y1: annotation.Type.value.Start?.Y,
          y2: annotation.Type.value.End?.Y,
        } as Annotation;
        polyLinesAcc.push(arrow);
      }
      if (annotation.Type.case === 'Ruler') {
        const ruler = {
          kind: 'ruler',
          x1: annotation.Type.value.Start?.X,
          x2: annotation.Type.value.End?.X,
          y1: annotation.Type.value.Start?.Y,
          y2: annotation.Type.value.End?.Y,
        } as Annotation;
        polyLinesAcc.push(ruler);
      }
      return polyLinesAcc;
    }, [] as Annotation[]);

    if (item.Annotations?.length) {
      annotationsAcc.push(...polyLines);
    }

    return annotationsAcc;
  }, [] as Annotation[]);
